import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";

import { MatTableDataSource } from "@angular/material/table";
import { MatSort, MatSortable } from '@angular/material/sort';
import { Client, Fund, User } from './master-visualizar-cliente.model';
import { MasterVisualizarClienteService } from "./master-visualizar-cliente.service";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from "rxjs";
import { style } from "@angular/animations";

/**
 * This Component manages the presentation logic of a view screen
 *
 */
@Component({
  selector: "app-master-visualizar-cliente",
  templateUrl: "./master-visualizar-cliente.component.html",
  styleUrls: ["./master-visualizar-cliente.component.scss"]
})
export class MasterVisualizarClienteComponent implements OnInit {
  id: any;
  client: Client;
  users: MatTableDataSource<User>;
  funds: MatTableDataSource<Fund>;

  usersComplete: any;
  fundsComplete: any;

  usersColumns = ["name", "login", "permissionGroup", "status"];
  fundsColumns = ["code", "name"];

  @ViewChild('sortUsers', { static: false }) sortUsers: MatSort;
  @ViewChild('sortFunds', { static: false }) sortFunds: MatSort;

  userFilter: any;
  fundFilter: any;

  subscription: Subscription;

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private clientService: MasterVisualizarClienteService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MasterVisualizarClienteComponent>,
  ) { }

  ngOnInit() {
    this.getClient();
  }

  getClient() {
    this.subscription = this.clientService.getClientByClientId({id: this.id})
      .subscribe(response => {
        this.client = response;

        // normalizar strings
        this.client.users.forEach(item => {
          if (item.permissionGroup == '') item.permissionGroup = 'Nenhum';
        });

        this.users = new MatTableDataSource<User>(this.client.users.naturalSort([this.usersColumns[0]]));
        this.users.sortingDataAccessor = (data, sortHeaderId) => data[sortHeaderId].naturalNormalize();
        this.users.sort = this.sortUsers;

        this.funds = new MatTableDataSource<Fund>(this.client.funds.naturalSort([this.fundsColumns[0]]));
        this.funds.sortingDataAccessor = (data, sortHeaderId) => data[sortHeaderId].naturalNormalize();
        this.funds.sort = this.sortFunds;
      });
  }

  filterUsers(event: Event) {
    this.users.filterPredicate = (data, filter) => {
      if (data.name === null || data.name === undefined) {
        data.name = ''
      }
      return data.name.toLowerCase().includes(filter.toLowerCase());
    }

    this.userFilter = (event.target as HTMLInputElement).value;
    this.users.filter = this.userFilter;

    if (this.userFilter.length > 0 && this.userFilter.length % 2 == 0) {
      this.usersComplete = this.users.filteredData;
    } else if (this.userFilter.length == 0) {
      this.usersComplete = []
    }
  }

  filterFunds(event?: Event) {
    this.funds.filterPredicate = (data, filter) => {
      return data.code.toLowerCase().includes(filter.toLowerCase()) || data.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
    }
    this.fundFilter = (event.target as HTMLInputElement).value;
    this.funds.filter = this.fundFilter;

    if (this.fundFilter.length > 0 && this.fundFilter.length % 2 == 0) {
      this.fundsComplete = this.funds.filteredData
    } else if (this.fundFilter.length == 0) {
      this.fundsComplete = []
    }
  }

  doFechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  protected handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}
